export let config = {
	panel: [
		{
			id: 999,
			type: "",
			title: {
				en: "Highlighted Solutions",
				de: "Highlighted Solutions",
			},
			info: null,
			image: "",
			categories: [],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 1,
					type: "",
					title: {
						en: "EcoCam",
						de: "EcoCam",
					},
					info: "S50/60/70 MC-C engines with a wide cam profile",
					image: "/apps/configurators/shared/assets/images/content/EcoCam.jpg",
					categories: [1, 3],
					engines: [1],
					description:
						"The EcoCam is a low-cost, simple fuel saving product. This low-load optimized virtual cam gives you lower emissions and instant fuel savings between 10% and 60% load. The EcoCam enables efficient slow steaming with operational flexibility for mechanical engines and is available for engines with a wide exhaust camshaft.<br><br>The EcoCam enables a variable cam profile without any mechanical modification of the camshaft itself. It is based on flexible exhaust valve timing that enables adjustment of the closing time of the exhaust valves according to engine load. The EcoCam solution includes an amendment to the existing technical file.<br><br>Key benefits:<ul><li>Fuel savings between 2 and 6 g/kWh</li><li>Slow steaming with operational flexibility</li><li>Easy installation</li><li>High return on investment</li><li>Easy to operate (automatic)</li><li>Effective between 10% and 60% load</li><li>No exchange of exhaust cam required</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_ecocam_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 2,
					type: "",
					title: {
						en: "EcoNozzle",
						de: "EcoNozzle",
					},
					info: "S50MC-C Mark 7/8",
					image:
						"/apps/configurators/shared/assets/images/content/EcoNozzle.jpg",
					categories: [1, 2],
					engines: [1],
					description:
						"Fuel savings with the EcoNozzle, the latest addition to the new Eco family designed to provide fuel savings in the entire load range! With this concept fitted, your engine will have state-of–the-art combustion control. Fuel savings in the area of 2-7 g/kWh depending on the engine load, which gives a payback time down to 3-5 months.<br><br>The EcoNozzle fits the existing slide fuel valve and replacements can be done during a regular overhaul. The EcoNozzle is a wear part with the same TBO as the original fuel nozzle. It can easily be fitted right away, or when the old fuel nozzle must be changed anyway.<br><br>Key benefits:<ul><li>Instant fuel savings across the full load range</li><li>Easy, crew-level installation</li><li>High return on investment</li><li>Full operational flexibility</li><li>Reduced CO₂ and NOx emissions</li><li>Simple retrofit of the original wear part</li><li>Smart alternative to the previous fuel nozzle</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_econozzle_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 3,
					type: "",
					title: {
						en: "Flexible Turbocharger Cut-Out",
						de: "Flexible Turbocharger Cut-Out",
					},
					info: "All Everllence B&W MC/MC-C and ME/ME-C engines with two or more turbochargers",
					image:
						"/apps/configurators/shared/assets/images/content/Flexible-Turbocharger-Cut-Out.png",
					categories: [1, 2, 3],
					engines: [1],
					description:
						'By installing a turbocharger cut-out system, the operator has the option of disabling one or more of the turbochargers for low-load operation. Thereby, the performance of the remaining turbochargers will be improved, which reduces SFOC. <br><br>Out of the total operational costs of a ship, fuel costs account for by far the highest proportion. Low-load operation, also well known as "slow steaming", represents the currently most effective and popular measure to cut fuel costs and in consequence the total operational costs. The Flexible Turbocharger Cut-Out has been very well received in the shipping world, with more than 500 systems in operation worldwide <br><br>Key benefits:<ul><li>Improved performance of the remaining turbochargers</li><li>Improved combustion thereby cleaner engine</li><li>Fuel savings up to 6g/kWh</li><li>Short payback time</li><li>High flexibility</li></ul>',
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_flexible-turbocharger-cut-out_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 4,
					type: "",
					title: {
						en: "LNG dual-fuel conversion",
						de: "LNG dual-fuel conversion",
					},
					info: "Available for ME-C engines with 50 cylinder bore and higher with mark 8.2 or above",
					image:
						"/apps/configurators/shared/assets/images/content/LNG_dual-fuel.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"A dual-fuel ME-GI retrofit conversion allows your vessel to operate on both traditional fuel oils and LNG. This conversion offers significant benefits in fuel flexibility, emissions reduction, and regulatory compliance. With 190 LNG bunkering ports worldwide and 80 more under development, the methane decarbonization pathway has become mainstream. This one-time capital investment, combined with the competitiveness of LNG as a bunker fuel makes it a practical and cost-effective way to maximize asset value and while making your vessel ready to comply with tightening emissions rules.<br><br>Key benefits: <ul><li>Refined Everllence B&W engine design with over 4 million running hours</li><li>Flexible operation using fuel oils or methane (LNG/bioLNG/e-LNG)</li><li>Significant improvement in overall emissions profile of vessels</li><li>Proven concept with several conversions completed successfully with 24/7 onshore support from Everllence via PrimeServ Assist</li><li>Approx. 190 LNG bunkering ports exist worldwide, with 80 in development</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_dfc-me-gi_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 5,
					type: "",
					title: {
						en: "Methanol dual-fuel conversion",
						de: "Methanol dual-fuel conversion",
					},
					info: "Available for ME-C engines with S/G50, S/G60, S/G80, S/G90 and G95 cylinder bores, mark 9 or higher",
					image:
						"/apps/configurators/shared/assets/images/content/Methanol_dual-fuel.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"Transform your vessel with a dual-fuel ME-LGIM retrofit conversion, dramatically reducing greenhouse gas emissions and ensuring compliance with current and future environmental regulations. This upgrade significantly enhances your operational profile. Operate your existing vessels on methanol at the same cost as a dual-fuel new-build, supporting your compliance with emissions regulations, including CII. Extend the lifetime value of your fleet with this competitive, sustainable conversion upgrade.<br><br>Key benefits: <ul><li>Methanol is liquid in ambient air conditions and therefore easier and cheaper to store on the vessel</li><li>Carbon-neutral on green methanol</li><li>SOₓ reduction of 90-97%</li><li>NOₓ reduction of 30-50%</li><li>Particular matter reduction of 90%</li><li>Positive impact on EEXI</li><li>Fuel flexibility with two different modes: <ul><li>Dual-fuel operation with minimum pilot oil amount</li><li>Compliant fuel oil-only mode</li></ul></li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_dfc-me-lgim_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 6,
					type: "",
					title: {
						en: "LPG dual-fuel conversion",
						de: "LPG dual-fuel conversion",
					},
					info: "Available for ME-C engines with G50 or S/G60 cylinder bore with mark 9 or above",
					image:
						"/apps/configurators/shared/assets/images/content/LPG_dual-fuel.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"Upgrade your Everllence B&W ME-C series engine to a dual-fuel ME-LGIP engine, enabling operation on both traditional fuel oils and Liquefied Petroleum Gas (LPG). This full-scale conversion offers flexibility with various LPG configurations and allows LPG cargo to be used as fuel, helping you meet environmental targets. Support your fleet in reducing OPEX, complying with environmental standards, and staying competitive in an evolving market.<br><br>Key benefits: <ul><li>Significant emissions reductions: <ul><li>SOₓ (90-97% reduction)</li><li>CO₂ (18% reduction)</li><li>NOₓ (15-25% reduction - SCR is needed for Tier III compliance)</li><li>PM (90% reduction)</li><li>EEXI (20% improvement)</li></ul></li><li>Proven concept following many successful ME-LGIP conversions</li><li>Flexible operation using fuel oil or LPG</li><li>Ability to use LPG cargo as a fuel source provides significant cost savings for LPG carriers</li><li>Combustion cleanliness reduces cylinder liner deposits</li><li>Everllence B&W ME-LGIP engines are connectivity-ready for services such as PrimeServ Assist</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_dfc-me-lgip_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 7,
					type: "",
					title: {
						en: "Ethane dual-fuel conversion",
						de: "Ethane dual-fuel conversion",
					},
					info: "Available for ME-C engines with G50 or G60 cylinder bore with mark 9.5",
					image:
						"/apps/configurators/shared/assets/images/content/Ethane_dual-fuel.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"Upgrade your vessel with a dual-fuel ME-GIE retrofit conversion to use ethane cargo as fuel, allowing it sail faster with the same carbon intensity and carry more ethane cargo. This full-scale conversion not only enhances operational fuel flexibility but also significantly reduces emissions and supports compliance with stringent environmental regulations. Investing in an ME-GIE retrofit turns your Everllence B&W ME-C series engine into a versatile dual-fuel system. This strategic investment offers an economical way to ensure your vessel is on par with the new market standard, boosting your asset's value.<br><br>Key benefits: <ul><li>Advanced Everllence B&W engine design with extensive operational experience</li><li>Dual-fuel capability to operate with both fuel oils and ethane cargo as fuel</li><li>Allows carriage of maximum cargo as vessel can reduce onboard fuel oil storage</li><li>Major reduction in emissions, supporting environmental compliance</li><li>Extensive 24/7 on-shore support from Everllence ES via PrimeServ Assist</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
					],
				},
				{
					id: 10,
					type: "",
					title: {
						en: "PMI Adaptive Cylinder Control (ACCo)",
						de: "PMI Adaptive Cylinder Control (ACCo)",
					},
					info: "All ME-C engines and following ME-B engines: 8.3, 8.5, 9.3 and 9.5",
					image:
						"/apps/configurators/shared/assets/images/content/PMI-ACCo.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"A successor to PMI Auto-tuning, PMI Adaptive Cylinder Control is a fully automatic system that will constantly help you secure optimal engine tuning regardless of engine load, load range, load changes, and varying fuel calorific values.<br><br>With PMI Adaptive Cylinder Control, Everllence takes engine tuning to the next level. Using a new, patented algorithm, closed loop control ensures that each individual cylinder always operates at its optimal cylinder pressure. This gives you the best engine performance and lowest possible fuel consumption at all times.<br><br>Key benefits:<ul><li>~1.5 g/kWh fuel savings</li><li>Pmax deviations add ~0.25 g/kWh savings per bar</li><li>Fully automatic system</li><li>Lowest possible fuel consumption at all times</li><li>Improved reliability and tuning of the engine</li><li>Slow-steaming support</li><li>Automatic adjustment for fuel variations</li><li>Great return on investment</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_pmi-adaptive-cylinder-control_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 9,
					type: "",
					title: {
						en: "EcoTuning",
						de: "EcoTuning",
					},
					info: "ME/ME-C engines ",
					image:
						"/apps/configurators/shared/assets/images/content/EcoTuning.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"EcoTuning is a powerful tailor-engineered part-load tuning that reduces the engine’s fuel oil consumption significantly, supporting your in-service fleet’s decarbonization. It is specifically designed for Everllence B&W two-stroke ME and ME-C engines, and secures significant fuel oil savings, resulting in reduced CO₂ emissions and fuel costs.<br><br>Using engineering calibration, EcoTuning increases engine efficiency. This is achieved through software-based fine-tuning of the maximum combustion pressure across the entire load range. As a result, the combustion pressure will match the load profile of your specific vessel.<br><br>Key benefits:<ul><li>Significant fuel oil savings up to 7 g/kwh, depending on the desired load profile</li><li>Substantial emission reductions support higher Carbon Intensity Indicator ratings and stronger decarbonization regulatory compliance</li><li>Simple installation with no operational downtime</li><li>No requirement for sea trials or service tests</li><li>EcoTuning can be updated if your vessel’s operations pattern change, ensuring peak performance</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_ecotuning_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 11,
					type: "",
					title: {
						en: "AutoTorque",
						de: "AutoTorque",
					},
					info: "All Everllence B&W ME/ME-B/ME-C engines with FPP propeller",
					image:
						"/apps/configurators/shared/assets/images/content/EcoTorque.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"AutoTorque is a fully automatic engine control upgrade that optimizes engine speed in medium sea waves, reducing fuel oil consumption and eliminating manual governor mode selection.<br><br>At Everllence, we strive to support ship operators in meeting the demands of modern shipping by enhancing our solutions for greater efficiency, reliability, and sustainability. This is why we developed AutoTorque, a retrofit upgrade built on the proven EcoTorque system. With its new features, AutoTorque enables shipowners to further optimize fuel consumption.",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_autotorque_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 12,
					type: "",
					title: {
						en: "Low Sulphur Fuel Nozzle",
						de: "Low Sulphur Fuel Nozzle",
					},
					info: "All Everllence B&W two-stroke engines operating on LSFO/VLSFO",
					image:
						"/apps/configurators/shared/assets/images/content/EcoNozzle.jpg",
					categories: [2],
					engines: [1, 2],
					description:
						"Ensure a service life of 8,000 running hours with the low sulphur fuel nozzle, engineered to withstand the increased thermal stresses and temperature fluctuations inherent in operating on low viscosity fuels such as LSFO and VLSFO.<br><br>As the maritime industry transitions to alternative fuel oils to comply with environmental regulations, operators may encounter new technical challenges. One such challenge is that low viscosity fuel oils can cause greater temperature fluctuations during thermal cycles between combustion and fuel injection. These repeated cycles cause nozzle materials to expand and contract, increasing the risk of fatigue and microcracking.",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ps_low-sulphur-fuel-nozzle_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 1000,
			type: "",
			title: {
				en: "Decarbonization & fuel efficiency",
				de: "Decarbonization & fuel efficiency",
			},
			info: null,
			image: "",
			categories: [],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 100,
					type: "",
					title: {
						en: "EcoCam",
						de: "EcoCam",
					},
					info: "S50/60/70 MC-C engines with a wide \ncam profile",
					image: "/apps/configurators/shared/assets/images/content/EcoCam.jpg",
					categories: [1, 3],
					engines: [1],
					description:
						"The EcoCam is a low-cost, simple fuel saving product. This low-load optimized virtual cam gives you lower emissions and instant fuel savings between 10% and 60% load. The EcoCam enables efficient slow steaming with operational flexibility for mechanical engines and is available for engines with a wide exhaust camshaft.<br><br>The EcoCam enables a variable cam profile without any mechanical modification of the camshaft itself. It is based on flexible exhaust valve timing that enables adjustment of the closing time of the exhaust valves according to engine load. The EcoCam solution includes an amendment to the existing technical file.<br><br>Key benefits:<ul><li>Fuel savings between 2 and 6 g/kWh</li><li>Slow steaming with operational flexibility</li><li>Easy installation</li><li>High return on investment</li><li>Easy to operate (automatic)</li><li>Effective between 10% and 60% load</li><li>No exchange of exhaust cam required</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_ecocam_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 101,
					type: "",
					title: {
						en: "EcoNozzle",
						de: "EcoNozzle",
					},
					info: "S50MC-C Mark 7/8",
					image:
						"/apps/configurators/shared/assets/images/content/EcoNozzle.jpg",
					categories: [1, 3],
					engines: [1],
					description:
						"Fuel savings with the EcoNozzle, the latest addition to the new Eco family designed to provide fuel savings in the entire load range! With this concept fitted, your engine will have state-of–the-art combustion control. Fuel savings in the area of 2-7 g/kWh depending on the engine load, which gives a payback time down to 3-5 months.<br><br>The EcoNozzle fits the existing slide fuel valve and replacements can be done during a regular overhaul. The EcoNozzle is a wear part with the same TBO as the original fuel nozzle. It can easily be fitted right away, or when the old fuel nozzle must be changed anyway.<br><br>Key benefits:<ul><li>Instant fuel savings across the full load range</li><li>Easy, crew-level installation</li><li>High return on investment</li><li>Full operational flexibility</li><li>Reduced CO₂ and NOx emissions</li><li>Simple retrofit of the original wear part</li><li>Smart alternative to the previous fuel nozzle</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_econozzle_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 102,
					type: "",
					title: {
						en: "Flexible Turbocharger Cut-Out",
						de: "Flexible Turbocharger Cut-Out",
					},
					info: "All Everllence B&W MC/MC-C and ME/ME-C engines with two or more turbochargers",
					image:
						"/apps/configurators/shared/assets/images/content/Flexible-Turbocharger-Cut-Out.png",
					categories: [1, 2, 3],
					engines: [1],
					description:
						'By installing a turbocharger cut-out system, the operator has the option of disabling one or more of the turbochargers for low-load operation. Thereby, the performance of the remaining turbochargers will be improved, which reduces SFOC. <br><br>Out of the total operational costs of a ship, fuel costs account for by far the highest proportion. Low-load operation, also well known as "slow steaming", represents the currently most effective and popular measure to cut fuel costs and in consequence the total operational costs. The Flexible Turbocharger Cut-Out has been very well received in the shipping world, with more than 500 systems in operation worldwide <br><br>Key benefits:<ul><li>Improved performance of the remaining turbochargers</li><li>Improved combustion thereby cleaner engine</li><li>Fuel savings up to 6g/kWh</li><li>Short payback time</li><li>High flexibility</li></ul>',
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_flexible-turbocharger-cut-out_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 108,
					type: "",
					title: {
						en: "PMI VIT",
						de: "PMI VIT",
					},
					info: "All Everllence B&W 50-98 MC/MC-C engines with a VIT rack installed",
					image:
						"/apps/configurators/shared/assets/images/content/Auto-tuning.jpg",
					categories: [1, 2, 3],
					engines: [1],
					description:
						"The Performance Measurement Indicator Variable Injection Timing (PMI VIT) system is used for mechanically controlled Everllence B&W two-stroke engines and ensures the optimal cylinder pressure by controlling fuel-injection timing via an electronic actuator on the VIT (variable injection timing) rack, based on pressure data from the PMI sensors.<br><br>This increases the maximum cylinder pressure (Pmax) to improve the combustion, which can reduce the fuel consumption and, consequently, CO₂ emissions. The system displays various performance data on a screen, informing the crew of opportunities for additional engine tuning<br><br>Key benefits:<ul><li>Saves a substantial amount of fuel</li><li>Improves performance and engine efficiency</li><li>Lowers engine maintenance costs and increases reliability</li><li>Adjusts the engine automatically in response to ambient conditions and fuel properties</li><li>Simplifies operability to ease the workload and eliminate time-consuming manual adjustment</li><li>Diminishes the risk of human errors thanks to automatic parameter adjustment</li><li>Reduces SFOC leading to CO₂ reduction, which helps to improve the CII rating and bring down EU ETS carbon costs</li><li>Reduces carbon particle emission</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_pmi-vit_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 110,
					type: "",
					title: {
						en: "Flexible Turbocharger Cut-Out",
						de: "Flexible Turbocharger Cut-Out",
					},
					info: "All Everllence B&W MC/MC-C and ME/ME-C engines with two or more turbochargers",
					image:
						"/apps/configurators/shared/assets/images/content/Flexible-Turbocharger-Cut-Out.png",
					categories: [1, 2, 3],
					engines: [2],
					description:
						'By installing a turbocharger cut-out system, the operator has the option of disabling one or more of the turbochargers for low-load operation. Thereby, the performance of the remaining turbochargers will be improved, which reduces SFOC. <br><br>Out of the total operational costs of a ship, fuel costs account for by far the highest proportion. Low-load operation, also well known as "slow steaming", represents the currently most effective and popular measure to cut fuel costs and in consequence the total operational costs. The Flexible Turbocharger Cut-Out has been very well received in the shipping world, with more than 500 systems in operation worldwide <br><br>Key benefits:<ul><li>Improved performance of the remaining turbochargers</li><li>Improved combustion thereby cleaner engine</li><li>Fuel savings up to 6g/kWh</li><li>Short payback time</li><li>High flexibility</li></ul>',
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_flexible-turbocharger-cut-out_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 111,
					type: "",
					title: {
						en: "EcoTuning",
						de: "EcoTuning",
					},
					info: "ME/ME-C engines ",
					image:
						"/apps/configurators/shared/assets/images/content/EcoTuning.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"EcoTuning is a powerful tailor-engineered part-load tuning that reduces the engine’s fuel oil consumption significantly, supporting your in-service fleet’s decarbonization. It is specifically designed for Everllence B&W two-stroke ME and ME-C engines, and secures significant fuel oil savings, resulting in reduced CO₂ emissions and fuel costs.<br><br>Using engineering calibration, EcoTuning increases engine efficiency. This is achieved through software-based fine-tuning of the maximum combustion pressure across the entire load range. As a result, the combustion pressure will match the load profile of your specific vessel.<br><br>Key benefits:<ul><li>Significant fuel oil savings up to 7 g/kwh, depending on the desired load profile</li><li>Substantial emission reductions support higher Carbon Intensity Indicator ratings and stronger decarbonization regulatory compliance</li><li>Simple installation with no operational downtime</li><li>No requirement for sea trials or service tests</li><li>EcoTuning can be updated if your vessel’s operations pattern change, ensuring peak performance</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_ecotuning_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 112,
					type: "",
					title: {
						en: "EcoTorque",
						de: "EcoTorque",
					},
					info: "All Everllence B&W ME/ME-B/ME-C engines with FPP propeller",
					image:
						"/apps/configurators/shared/assets/images/content/EcoTorque.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"EcoTorque is a governor control update developed to improve cylinder liner condition and lower fuel consumption. By governing the engine within a specified speed range instead of a steady RPM, EcoTorque ensures a stable fuel index.<br><br>EcoTorque is the new default governor setting that actively controls the engine to keep the fuel index steady, thereby stabilizing the torque by letting the engine’s speed float within a specified range.<br><br>The stabilized fuel index results in lower fuel consumption. Compared to operating the engine in “RPM mode”, experience shows that “Torque mode” saves approx. 1 g/kWh on the specific fuel oil consumption, while maintaining the same vessel speed.<br><br>Key benefits:<ul><li>Improved cylinder liner condition</li><li>Smoother engine operation</li><li>The effect of external conditions on engine operation is minimized</li><li>Prolongs the time between overhauls for cylinder liners and piston rings</li><li>Approx. 1 g/kWh lower SFOC than in “rpm mode” Easy installation – no attendance required by Everllence PrimeServ (installation with the parameter update tool (PUT))</li><li>Great return on investment</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_ecotorque_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 125,
					type: "",
					title: {
						en: "AutoTorque",
						de: "AutoTorque",
					},
					info: "All Everllence B&W ME/ME-B/ME-C engines with FPP propeller",
					image:
						"/apps/configurators/shared/assets/images/content/EcoTorque.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"AutoTorque is a fully automatic engine control upgrade that optimizes engine speed in medium sea waves, reducing fuel oil consumption and eliminating manual governor mode selection.<br><br>At Everllence, we strive to support ship operators in meeting the demands of modern shipping by enhancing our solutions for greater efficiency, reliability, and sustainability. This is why we developed AutoTorque, a retrofit upgrade built on the proven EcoTorque system. With its new features, AutoTorque enables shipowners to further optimize fuel consumption.",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_autotorque_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 113,
					type: "",
					title: {
						en: "PMI Auto-tuning",
						de: "PMI Auto-tuning",
					},
					info: "ME/ME-C, ME-B",
					image:
						"/apps/configurators/shared/assets/images/content/Auto-tuning.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"Our PMI systems are built around the same basic process: A monitoring unit uses a transducer on each cylinder to monitor cylinder pressure, and the pressure data is then used to automatically balance and tune the engine. The latter step is where the configurations differ. The performance data is also displayed on a screen, keeping the crew aware of opportunities for additional engine tuning.<br><br>PMI Auto-tuning is used for electronically controlled Everllence B&W two-stroke engines. This PMI system configuration ensures the optimal cylinder pressure by adjusting the fuel-injection timing and the opening of the exhaust valve.<br><br>Key benefits:<ul><li>CO₂ reduction due to SFOC reduction</li><li>Carbon particle reduction</li><li>Fuel oil consumption</li><li>Reduced engine maintenance costs</li><li>Increase availability/reliability</li><li>Keeping Pmax within limits</li><li>Ease workload on crew</li><li>Ensuring always optimized engine</li><li>Automatic adaptation to changing fuel properties</li><li>Ease of combustion process troubleshooting</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_pmi-autotuning_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 114,
					type: "",
					title: {
						en: "PMI Adaptive Cylinder Control (ACCo)",
						de: "PMI Adaptive Cylinder Control (ACCo)",
					},
					info: "All ME-C engines and following ME-B engines: 8.3, 8.5, 9.3 and 9.5",
					image:
						"/apps/configurators/shared/assets/images/content/PMI-ACCo.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"A successor to PMI Auto-tuning, PMI Adaptive Cylinder Control is a fully automatic system that will constantly help you secure optimal engine tuning regardless of engine load, load range, load changes, and varying fuel calorific values.<br><br>With PMI Adaptive Cylinder Control, Everllence takes engine tuning to the next level. Using a new, patented algorithm, closed loop control ensures that each individual cylinder always operates at its optimal cylinder pressure. This gives you the best engine performance and lowest possible fuel consumption at all times.<br><br>Key benefits:<ul><li>~1.5 g/kWh fuel savings</li><li>Pmax deviations add ~0.25 g/kWh savings per bar</li><li>Fully automatic system</li><li>Lowest possible fuel consumption at all times</li><li>Improved reliability and tuning of the engine</li><li>Slow-steaming support</li><li>Automatic adjustment for fuel variations</li><li>Great return on investment</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_pmi-adaptive-cylinder-control_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 500,
					type: "",
					title: {
						en: "LNG dual-fuel conversion",
						de: "LNG dual-fuel conversion",
					},
					info: "Available for ME-C engines with 50 cylinder bore and higher with mark 8.2 or above",
					image:
						"/apps/configurators/shared/assets/images/content/LNG_dual-fuel.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"A dual-fuel ME-GI retrofit conversion allows your vessel to operate on both traditional fuel oils and LNG. This conversion offers significant benefits in fuel flexibility, emissions reduction, and regulatory compliance. With 190 LNG bunkering ports worldwide and 80 more under development, the methane decarbonization pathway has become mainstream. This one-time capital investment, combined with the competitiveness of LNG as a bunker fuel makes it a practical and cost-effective way to maximize asset value and while making your vessel ready to comply with tightening emissions rules.<br><br>Key benefits: <ul><li>Refined Everllence B&W engine design with over 4 million running hours</li><li>Flexible operation using fuel oils or methane (LNG/bioLNG/e-LNG)</li><li>Significant improvement in overall emissions profile of vessels</li><li>Proven concept with several conversions completed successfully with 24/7 onshore support from Everllence via PrimeServ Assist</li><li>Approx. 190 LNG bunkering ports exist worldwide, with 80 in development</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_dfc-me-gi_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 501,
					type: "",
					title: {
						en: "Methanol dual-fuel conversion",
						de: "Methanol dual-fuel conversion",
					},
					info: "Available for ME-C engines with S/G50, S/G60, S/G80, S/G90 and G95 cylinder bores, mark 9 or higher",
					image:
						"/apps/configurators/shared/assets/images/content/Methanol_dual-fuel.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"Transform your vessel with a dual-fuel ME-LGIM retrofit conversion, dramatically reducing greenhouse gas emissions and ensuring compliance with current and future environmental regulations. This upgrade significantly enhances your operational profile. Operate your existing vessels on methanol at the same cost as a dual-fuel new-build, supporting your compliance with emissions regulations, including CII. Extend the lifetime value of your fleet with this competitive, sustainable conversion upgrade.<br><br>Key benefits: <ul><li>Methanol is liquid in ambient air conditions and therefore easier and cheaper to store on the vessel</li><li>Carbon-neutral on green methanol</li><li>SOₓ reduction of 90-97%</li><li>NOₓ reduction of 30-50%</li><li>Particular matter reduction of 90%</li><li>Positive impact on EEXI</li><li>Fuel flexibility with two different modes: <ul><li>Dual-fuel operation with minimum pilot oil amount</li><li>Compliant fuel oil-only mode</li></ul></li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_dfc-me-lgim_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 502,
					type: "",
					title: {
						en: "LPG dual-fuel conversion",
						de: "LPG dual-fuel conversion",
					},
					info: "Available for ME-C engines with G50 or S/G60 cylinder bore with mark 9 or above",
					image:
						"/apps/configurators/shared/assets/images/content/LPG_dual-fuel.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"Upgrade your Everllence B&W ME-C series engine to a dual-fuel ME-LGIP engine, enabling operation on both traditional fuel oils and Liquefied Petroleum Gas (LPG). This full-scale conversion offers flexibility with various LPG configurations and allows LPG cargo to be used as fuel, helping you meet environmental targets. Support your fleet in reducing OPEX, complying with environmental standards, and staying competitive in an evolving market.<br><br>Key benefits: <ul><li>Significant emissions reductions: <ul><li>SOₓ (90-97% reduction)</li><li>CO₂ (18% reduction)</li><li>NOₓ (15-25% reduction - SCR is needed for Tier III compliance)</li><li>PM (90% reduction)</li><li>EEXI (20% improvement)</li></ul></li><li>Proven concept following many successful ME-LGIP conversions</li><li>Flexible operation using fuel oil or LPG</li><li>Ability to use LPG cargo as a fuel source provides significant cost savings for LPG carriers</li><li>Combustion cleanliness reduces cylinder liner deposits</li><li>Everllence B&W ME-LGIP engines are connectivity-ready for services such as PrimeServ Assist</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_dfc-me-lgip_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 503,
					type: "",
					title: {
						en: "Ethane dual-fuel conversion",
						de: "Ethane dual-fuel conversion",
					},
					info: "Available for ME-C engines with G50 or G60 cylinder bore with mark 9.5",
					image:
						"/apps/configurators/shared/assets/images/content/Ethane_dual-fuel.jpg",
					categories: [1, 2, 3],
					engines: [2],
					description:
						"Upgrade your vessel with a dual-fuel ME-GIE retrofit conversion to use ethane cargo as fuel, allowing it sail faster with the same carbon intensity and carry more ethane cargo. This full-scale conversion not only enhances operational fuel flexibility but also significantly reduces emissions and supports compliance with stringent environmental regulations. Investing in an ME-GIE retrofit turns your Everllence B&W ME-C series engine into a versatile dual-fuel system. This strategic investment offers an economical way to ensure your vessel is on par with the new market standard, boosting your asset's value.<br><br>Key benefits: <ul><li>Advanced Everllence B&W engine design with extensive operational experience</li><li>Dual-fuel capability to operate with both fuel oils and ethane cargo as fuel</li><li>Allows carriage of maximum cargo as vessel can reduce onboard fuel oil storage</li><li>Major reduction in emissions, supporting environmental compliance</li><li>Extensive 24/7 on-shore support from Everllence ES via PrimeServ Assist</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
					],
				},
			],
		},
		{
			id: 2000,
			type: "",
			title: {
				en: "Operational Efficiency",
				de: "Operational Efficiency",
			},
			info: null,
			image: "",
			categories: [],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 104,
					type: "",
					title: {
						en: "Alpha lubricator MC upgrade",
						de: "Alpha lubricator MC upgrade",
					},
					info: "MC/MC-C",
					image:
						"/apps/configurators/shared/assets/images/content/Alpha-Lub-MC-Upgrade.jpg",
					categories: [2],
					engines: [1],
					description:
						"The alpha lubricator upgrade is a major improvement of the system. By adopting the new lubricator layout, complete lubrication optimisation at all engine loads is now possible.<br><br>The alpha lubricator upgrade has been introduced as a retrofit solution, to optimize the cylinder oil consumption on existing engines. Along with a number of design improvements, the injection volume and frequency have been changed in order to optimize the cylinder oil consumption at low loads.<br><br>Key benefits:<ul><li>Cylinder lubrication oil savings of 20-50% at low load</li><li>More accurate feed rate control at all engine loads</li><li>Minimising over-lubrication at low load, reducing deposits, hence improving the cylinder condition</li><li>Implementation of design features</li><li>Upgraded interface to the latest software version</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_alpha-lub-upgrade-mc_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 115,
					type: "",
					title: {
						en: "Alpha lubricator ME upgrade",
						de: "Alpha lubricator ME upgrade",
					},
					info: "All Everllence B&W ME/ME-C/ME-B engine",
					image:
						"/apps/configurators/shared/assets/images/content/Alpha-Lub-ME-Upgrade.png",
					categories: [2],
					engines: [2],
					description:
						"The Alpha Lubricator ME upgrade reduces cylinder liner wear and optimizes the cylinder lube oil consumption. The upgrade consists of plungers and a software update to optimize existing lubricators.<br><br>Key benefits:<ul><li>Reduced iron content in the drain oil</li><li>More accurate lube oil feed rate control at all engine loads</li><li>Minimizes over-lubrication at low load to reduce deposits and improve the cylinder condition</li><li>Implements features from a more recent engine design</li><li>Upgrade to the latest software version for improved functionality</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_alpha-lub-upgrade-me_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 118,
					type: "",
					title: {
						en: "ECS EasyDetect",
						de: "ECS EasyDetect",
					},
					info: "ME/ME-C, ME-B",
					image:
						"/apps/configurators/shared/assets/images/content/ECS-EasyDetect.jpg",
					categories: [2, 4],
					engines: [2],
					description:
						"An upgrade of the engine control system power supply enables easy troubleshooting and improved reliability.<br><br>The upgrade separates the power supply for all MPCs in the ECS (fig.1), equips all controllers with isolation resistance monitoring (IRM) modules (fig. 2) and updates the ECS-software. This upgrade enables easy monitoring of the isolation resistance on each individual controller of the ECS, which is displayed on the MOP (fig. 3) and logged in the CoCoS engine diagnostics system.<br><br>With these new tools at hand, the troubleshooting efforts can be focused on the correct part of the system and the data logs allow for any correlation with other events to be tracked, making troubleshooting faster and easier.<br><br>Key benefits:<ul><li>Swift identification in case of cable failures or loose connections</li><li>Quick identification of defective components, i.e. sensors, cables or controllers</li><li>Less downtime</li><li>Peace of mind for the crew knowing that they have the best troubleshooting tool available</li><li>Online monitoring of the isolation level as well as noise pulse counts</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_ecs-easy-detect_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 123,
					type: "",
					title: {
						en: "FIVA Retrofit",
						de: "FIVA Retrofit",
					},
					info: "ME/ME-C, ME-B",
					image:
						"/apps/configurators/shared/assets/images/content/FIVA-ELFI-ELVA.jpg",
					categories: [2, 4],
					engines: [2],
					description:
						"The FIVA (Fuel Injection Valve Actuation), ELFI (Electronic Fuel Injection) and ELVA (Electronic Valve Actuation) valves are an essential part of the ME engine to ensure optimal running performance. The electronic valves are high precision units which control either the fuel injection, the exhaust valve actuation or both of them. In this way, the electronic valves serves the same function on an electronically controlled ME engine as the camshaft on a mechanically controlled MC engine. <br><br>Curtiss-Wright (CWAT) has ceased their production of their electronic valves, so it is no longer possible to purchase new CWAT electronic valves. Everllence PrimeServ stopped the overhauling support of CWAT electronic valves. Hence, Everllence PrimeServ recommends a retrofit solution where we convert existing CWAT electronic valves to Everllence electronic valves. <br><br>Key benefits: <ul><li>Up-to-date technology and design</li><li>Increased lifetime</li><li>Factory overhaul</li><li>Everllence FIVA spares guaranteed</li><li>Worldwide service of FIVA valves</li><li>Reduced maintenance costs</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ps_FIVA_retrofit_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 126,
					type: "",
					title: {
						en: "Low Sulphur Fuel Nozzle",
						de: "Low Sulphur Fuel Nozzle",
					},
					info: "All Everllence B&W two-stroke engines operating on LSFO/VLSFO",
					image:
						"/apps/configurators/shared/assets/images/content/EcoNozzle.jpg",
					categories: [2],
					engines: [1, 2],
					description:
						"Ensure a service life of 8,000 running hours with the low sulphur fuel nozzle, engineered to withstand the increased thermal stresses and temperature fluctuations inherent in operating on low viscosity fuels such as LSFO and VLSFO.<br><br>As the maritime industry transitions to alternative fuel oils to comply with environmental regulations, operators may encounter new technical challenges. One such challenge is that low viscosity fuel oils can cause greater temperature fluctuations during thermal cycles between combustion and fuel injection. These repeated cycles cause nozzle materials to expand and contract, increasing the risk of fatigue and microcracking.",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ps_low-sulphur-fuel-nozzle_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 3000,
			type: "",
			title: {
				en: "Regulatory Compliance",
				de: "Regulatory Compliance",
			},
			info: null,
			image: "",
			categories: [],
			engines: [],
			description: "",
			links: [],
			children: [
				{
					id: 105,
					type: "",
					title: {
						en: "Overridable Power Limitation MC",
						de: "Overridable Power Limitation MC",
					},
					info: "MC/MC-C",
					image:
						"/apps/configurators/shared/assets/images/content/EEXI-OPL-MC.jpg",
					categories: [3],
					engines: [1],
					description:
						"Overridable Power Limitation (OPL) is a retrofit solution designed to lower the energy efficiency index for existing ships (EEXI) by limiting the engine power of the existing fleet to comply with the IMO resolution MEPC 335 (76) adopted on 17 June 2021<br><br>OPL is a measure to limit the main engine’s maximum continuous rating (MCR), with the possibility to be overridden if the safety of the vessel is compromised. The OPL is a mechanical stopper device for limiting the fuel index. The solution is tamper proof, which includes that the OPL solution cannot be overriden via local control.<br><br>Key benefits:<ul><li>Simple solution, fast and easy way to limit the power output of engines or un-limit the engine if additional power is needed and allowed</li><li>No additional systems required</li><li>Easy installation, can be done by service engineer during normal port stay</li><li>OPL system can be activated on the first survey day in 2023</li><li>For MC engines, the OPL solution allows easy release and secures the reset of power limitation with no risk of overload</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_overridable-power-mc_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 106,
					type: "",
					title: {
						en: "Permanent Power Limitation MC",
						de: "Permanent Power Limitation MC",
					},
					info: "MC/MC-C",
					image:
						"/apps/configurators/shared/assets/images/content/Permanent-Power-Limitiation-MC.jpg",
					categories: [3],
					engines: [1],
					description:
						"Permanent Power Limitation (PPL) is a retrofit solution designed to lower the energy efficiency index for existing ships (EEXI) by limiting the engine power to comply with the IMO resolution MEPC 335(76) adopted on 17 June 2021.<br><br>PPL is a wire seal that limits the engine power by restricting the fuel index to a pre-calculated set value. Implementing the EEXI PPL solution allows the vessel to use the 75% PME rule given in the EEXI regulations MEPC.333(76) 2.2.1.<br><br>Key benefits:<ul><li>Simple solution – fast and easy way to limit the power output of MC engines</li><li>No additional systems necessary, such as remote controls and logging devices</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_permanent-power-mc_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},

				{
					id: 109,
					type: "",
					title: {
						en: "Slide Fuel Valve",
						de: "Slide Fuel Valve",
					},
					info: "MC/MC-C",
					image:
						"/apps/configurators/shared/assets/images/content/Slide-Fuel-Valve.jpg",
					categories: [3],
					engines: [1],
					description:
						"This type of valve reduces the amount of waste products, gives better combustion properties and is a must-have for slow-steaming operation.<br><br>The spray pattern of the fuel is further optimized leading to an improved and more complete combustion process. This results in less deposits throughout the gas ways and a reduction in overall emissions, such as HC, and particulate matter. The visible smoke level is also greatly reduced as a result of the improved combustion.<br><br>Key benefits:<ul><li>Improved low load performance</li><li>Cleaner combustion chamber</li><li>Cleaner exhaust gas pathways</li><li>Less visible smoke formation</li><li>Lower HC, and particulate emission</li><li>Improved cylinder condition</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_slide-fuel-valves_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 119,
					type: "",
					title: {
						en: "EngineVault",
						de: "EngineVault",
					},
					info: "ME/ME-C, ME-B",
					image:
						"/apps/configurators/shared/assets/images/content/EngineVault.jpg",
					categories: [3, 4],
					engines: [2],
					description:
						"EngineVault gives you the best possible protection of your main engine network from online and physical cyberattacks. Unique in the industry, it combines state-of-the-art software and hardware to provide firewall protection, comprehensive whitelisting and application-layer protection that seals off your engine network from virtually any threat – including on-board attacks via compromised USB flash drives and other physical media.<br><br>EngineVault protection involves three main security components:<ul><li>Full network hardening via port protection, encryption of all data received and transmitted, and advanced network segment segregation</li><li>Critical hardware protection via the latest state-of-the-art main operating panels for the engine control and management systems</li><li>Cutting-edge application-layer protection and extensive whitelisting that only allows Everllence-certified software on your engine network</li></ul><br><br>Key benefits:<ul><li>Uniquely effective protection against cybercrimes</li><li>Lower risk of service disruptions and off-hire periods</li><li>Greater safety for crews, and protection of physical assets</li><li>Compliance with regulations and IMO requirements</li><li>Peace of mind – ensure business continuity and protect your reputation</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_engine-vault_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 120,
					type: "",
					title: {
						en: "Overridable Power Limitation ME",
						de: "Overridable Power Limitation ME",
					},
					info: "ME/ME-C, ME-B",
					image:
						"/apps/configurators/shared/assets/images/content/EEXI-OPL-ME.jpg",
					categories: [1, 3],
					engines: [2],
					description:
						"Overridable Power Limitation (OPL) is a retrofit solution designed to lower the energy efficiency index for existing ships (EEXI) by limiting the engine power to comply with the IMO resolution MEPC 335(76) adopted on 17 of June 2021.<br><br>OPL for electronically controlled ME type engines is a solution that consists of software and hardware. The engine power is limited electronically by installing a new software and parameter file in the engine control system (ECS). The OPL is controlled via a remote operating panel consisting of a switch and control lamps installed either on the Bridge or in the engine control room.<br><br>Key benefits:<ul><li>Simple solution, fast and easy way to limit the power output of engines or un-limit the engine if additional power is needed and allowed</li><li>No additional equipment needed</li><li>Easy installation, can be done by service engineer during normal port stay</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_overridable-power-me_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 121,
					type: "",
					title: {
						en: "Permanent Power Limitation ME",
						de: "Permanent Power Limitation ME",
					},
					info: "ME/ME-C",
					image:
						"/apps/configurators/shared/assets/images/content/Permanent-Power-Limitiation-ME.jpg",
					categories: [3, 1],
					engines: [2],
					description:
						"Permanent Power Limitation (PPL) is a retrofit solution designed to lower the energy efficiency index for existing ships (EEXI) by limiting the engine power to comply with the IMO resolution MEPC 335(76) adopted on 17 June 2021. PPL for electronically controlled ME type engines is a solution consisting of software. The engine power is limited electronically by installing a new software and parameter file in the engine control system (ECS). The ECS calculates the engine load continuously. The calculation is based on engine speed, fuel index, and cylinder pressure. The fuel index will remain unlimited until the power limit is reached. Implementing the EEXI PPL solution allows the vessel to use the 75% PME rule given in the EEXI regulations MEPC.333(76) 2.2.1.<br><br>Key benefits: <ul><li>Simple solution – fast and easy way to limit the power output</li><li>No additional systems necessary, such as remote controls and logging devices</li><li>Easy installation – depending on the current ECS software version, as the installation can be done remotely or by an Everllence service engineer during a port stay</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_permanent-power-me_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 122,
					type: "",
					title: {
						en: "SOₓ Scrubber Engineering Services",
						de: "SOₓ Scrubber Engineering Services",
					},
					info: "All Everllence B&W MC/MC-C and ME/ME-C engines",
					image:
						"/apps/configurators/shared/assets/images/content/SOx-Scrubber-Engineering-Services---reports.jpg",
					categories: [3, 1, 2, 4],
					engines: [2],
					description:
						"Starting in January 2020, the global sulphur cap on marine fuels will be reduced from 3.50% to 0.50% sulphur. Continued use of high-sulphur HFO will be allowed if an exhaust gas cleaning (EGC) device is installed and certified, to comply with the new sulphur regulations. This device could be a SOₓ scrubber.<br><br> Retrofitting a SOₓ scrubber may require engine modifications and a technical file amendment to ensure continued compliance with IMO’s NOₓ Technical Code 2008. Everllence PrimeServ offers a SOₓ scrubber engineering service package with recommendations on the turbocharger rematching parts and approval by relevant classification societies if needed.<br><br> The turbocharger rematching will ensure that the fuel oil consumption will remain as optimal as before installation of a SOₓ scrubber, that NOₓ emission level will remain unchanged, and that the engine heat load will stay within the expected range.<br><br>Key benefits: <ul><li>Ensure optimal engine performance</li><li>Avoid heat load issues on exhaust valve piston, cover, fuel nozzle, etc.</li><li>Comply with the provisions of NOₓ Technical Code 2008</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_pmi-sox-scrubber-engineering-services_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
		{
			id: 4000,
			type: "",
			title: {
				en: "Safety Improvement",
				de: "Safety Improvement",
			},
			info: null,
			image: "",
			categories: [],
			engines: [2],
			description: "",
			links: [],
			children: [
				{
					id: 116,
					type: "",
					title: {
						en: "Safety screen filter",
						de: "Safety screen filter",
					},
					info: "ME/ME-C, ME-B",
					image:
						"/apps/configurators/shared/assets/images/content/Safety-Screen-Filter-type-2.png",
					categories: [4, 2],
					engines: [2],
					description:
						"The safety screen filter is a 100 micron filter developed for Everllence B&W ME/ME-C and ME-B engines. The filter ensures continuous operation of the multi-way valves by protecting the proportional valve from contaminants in the hydraulic oil. With its updated universal design, the filter can be mounted across all multi-way valves.<br><br>Key benefits: <ul><li>Protects the proportional valve against malfunction</li><li>Reduces risk of cover lift</li><li>Improves reliability</li><li>Ensures safety for crew</li><li>Easy installation by crew</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_safety-screen-filter_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 117,
					type: "",
					title: {
						en: "Load Optimizer",
						de: "Load Optimizer",
					},
					info: "All ME-C engines 80 bore and larger - mark 9 and newer",
					image:
						"/apps/configurators/shared/assets/images/content/Load-Optimizer.jpg",
					categories: [4, 2],
					engines: [2],
					description:
						"Load Optimizer is an engine control system update developed to improve cylinder liner condition and reduce excessive wear. Using a new set of features and functionalities, it protects the engine during load-up and load changes.<br><br>Load Optimizer actively protects the engine by a new set of features controlling the engine during load-up and during load changes. A new set of features protects your engine from sudden rapid power increases in the full load range. Such sudden power increases can occur if the external conditions for the vessel changes, and will cause the fuel index to rapidly increase, which can affect the cylinder condition adversely.<br><br>Your engine is further protected as Load Optimizer continuously quantify the actual engine load according to the nominal propeller curve and adjusts if the engine is running heavy.<br><br>Key benefits: <ul><li>Improved cylinder liner condition and protection of piston rings</li><li>Minimized unplanned maintenance</li><li>Reduced risk of unplanned cylinder liner and piston ring replacement</li><li>Fully automatic system</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ts_load-optimizer_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
				{
					id: 124,
					type: "",
					title: {
						en: "Super fine filter",
						de: "Super fine filter",
					},
					info: "All Everllence B&W ME/ME-C/ME-B engines with a specific filter type",
					image:
						"/apps/configurators/shared/assets/images/content/Super-Fine-Filter.jpg",
					categories: [4, 2],
					engines: [2],
					description:
						"The Super Fine Filter (SFF) is a filter element developed for electronically controlled ME/ME-C and ME-B engines. The Super Fine Filter improves the cleanliness of the hydraulic system oil and is now standard on new ME engines.<br><br>The ME engine consists of many expensive and fine-tolerance components, like the hydraulic power supply, FIVA/ ELFI valve, fuel booster, exhaust actuator, etc. The Super Fine Filter has been developed to improve the cleanliness of the hydraulic oil going to the ME engine, in order to keep it within the ME engine system cleanliness level. The SFF is fitted in the redundancy filter compartment.<br><br>The Super Fine Filter should be used once every month. We also recommend to use it after topping-up the hydraulic oil main tank. This will improve the cleanliness of the hydraulic oil going to the lubrication parts and the ME engine. Moreover, early replacement of ME engine components can be avoided.<br><br>Key benefits: <ul><li>Significantly reduced risk of damage to expensive ME engine components and internal lubrication parts</li><li>Improved cleanliness of hydraulic oil</li><li>No need to install separate system for hydraulic control oil</li><li>Low-cost solution</li><li>Plug & play – easy installation</li></ul>",
					links: [
						{
							text: {
								en: "Contact our experts",
								de: "Contact our experts",
							},
							url: "#contact",
							mode: "fill",
							type: "",
						},
						{
							text: {
								en: "Download flyer",
								de: "Download flyer",
							},
							url: "/apps/configurators/two-stroke-engines/assets/pdfs/evr-ps_super_fine_filter_PREVIEW.pdf",
							mode: "",
							type: "external",
						},
					],
				},
			],
		},
	],
	pluses: [
		{
			id: 1,
			x: 30,
			y: 23.5,
			text: "EcoCam",
			typeItemId: 1,
			type: "",
			direction: "right",
		},
		{
			id: 2,
			x: 25,
			y: 37,
			text: "EcoNozzle",
			typeItemId: 2,
			type: "",
			direction: "right",
		},
		{
			id: 3,
			x: 67,
			y: 22.5,
			text: "Flexible Turbocharger Cut-Out",
			typeItemId: 3,
			type: "",
			direction: "left",
		},
		{
			id: 4,
			x: 30,
			y: 23.5,
			text: "EcoCam",
			typeItemId: 100,
			type: "",
			direction: "right",
		},
		{
			id: 5,
			x: 25,
			y: 37,
			text: "EcoNozzle",
			typeItemId: 101,
			type: "",
			direction: "right",
		},
		{
			id: 6,
			x: 67,
			y: 22.5,
			text: "Flexible Turbocharger Cut-Out",
			typeItemId: 110,
			type: "",
			direction: "left",
		},
		{
			id: 7,
			x: 36,
			y: 43.5,
			text: "PMI VIT",
			typeItemId: 108,
			type: "",
			direction: "right",
		},
		{
			id: 7000,
			x: 32,
			y: 33,
			text: "Alpha lubricator MC upgrade",
			typeItemId: 104,
			type: "",
			direction: "right",
		},
		{
			id: 8000,
			x: 32,
			y: 49,
			text: "Overridable Power Limitation MC",
			typeItemId: 105,
			type: "",
			direction: "right",
		},
		{
			id: 9,
			x: 23,
			y: 39,
			text: "Permanent Power Limitation MC",
			typeItemId: 106,
			type: "",
			direction: "right",
		},
		{
			id: 10,
			x: 68,
			y: 33,
			text: "SOₓ Scrubber Engineering Services",
			typeItemId: 107,
			type: "",
			direction: "left",
		},
		{
			id: 11,
			x: 38,
			y: 38,
			text: "Slide Fuel Valve",
			typeItemId: 109,
			type: "",
			direction: "left",
		},
		{
			id: 12,
			x: 67,
			y: 22.5,
			text: "Flexible Turbocharger Cut-Out",
			typeItemId: 102,
			type: "",
			direction: "left",
		},
		{
			id: 13,
			x: 35,
			y: 22,
			text: "EcoTuning",
			typeItemId: 111,
			type: "",
			direction: "right",
		},
		{
			id: 14,
			x: 68,
			y: 67,
			text: "EcoTorque",
			typeItemId: 112,
			type: "",
			direction: "left",
		},
		{
			id: 15,
			x: 50,
			y: 24,
			text: "PMI Auto-tuning",
			typeItemId: 113,
			type: "",
			direction: "right",
		},
		{
			id: 16,
			x: 54,
			y: 40,
			text: "PMI Adaptive Cylinder Control (ACCo)",
			typeItemId: 114,
			type: "",
			direction: "left",
		},
		{
			id: 17,
			x: 60,
			y: 40,
			text: "LNG dual-fuel conversion",
			typeItemId: 500,
			type: "",
			direction: "left",
		},
		{
			id: 18,
			x: 42,
			y: 32,
			text: "Methanol dual-fuel conversion",
			typeItemId: 501,
			type: "",
			direction: "right",
		},
		{
			id: 19,
			x: 68,
			y: 67,
			text: "LPG dual-fuel conversion",
			typeItemId: 502,
			type: "",
			direction: "left",
		},
		{
			id: 20,
			x: 68,
			y: 33,
			text: "Ethane dual-fuel conversion",
			typeItemId: 503,
			type: "",
			direction: "left",
		},
		{
			id: 21,
			x: 51,
			y: 26,
			text: "Alpha lubricator ME upgrade",
			typeItemId: 115,
			type: "",
			direction: "right",
		},
		{
			id: 22,
			x: 65,
			y: 39,
			text: "ECS EasyDetect",
			typeItemId: 118,
			type: "",
			direction: "right",
		},
		{
			id: 23,
			x: 50,
			y: 50,
			text: "FIVA Retrofit",
			typeItemId: 123,
			type: "",
			direction: "right",
		},
		{
			id: 24,
			x: 35,
			y: 68,
			text: "EngineVault",
			typeItemId: 119,
			type: "",
			direction: "right",
		},
		{
			id: 25,
			x: 60,
			y: 41,
			text: "Overridable Power Limitation ME",
			typeItemId: 120,
			type: "",
			direction: "left",
		},
		{
			id: 26,
			x: 65,
			y: 28,
			text: "Permanent Power Limitation ME",
			typeItemId: 121,
			type: "",
			direction: "left",
		},
		{
			id: 27,
			x: 36,
			y: 25.5,
			text: "SOₓ Scrubber Engineering Services",
			typeItemId: 122,
			type: "",
			direction: "right",
		},
		{
			id: 28,
			x: 54.5,
			y: 28,
			text: "Safety screen filter",
			typeItemId: 116,
			type: "",
			direction: "right",
		},
		{
			id: 29,
			x: 55,
			y: 43,
			text: "Load Optimizer",
			typeItemId: 117,
			type: "",
			direction: "right",
		},
		{
			id: 30,
			x: 42,
			y: 39,
			text: "Super fine filter",
			typeItemId: 124,
			type: "",
			direction: "right",
		},
		{
			id: 31,
			x: 60,
			y: 28,
			text: "LNG dual-fuel conversion",
			typeItemId: 4,
			type: "",
			direction: "left",
		},
		{
			id: 32,
			x: 62,
			y: 42,
			text: "Methanol dual-fuel conversion",
			typeItemId: 5,
			type: "",
			direction: "left",
		},
		{
			id: 33,
			x: 70,
			y: 35,
			text: "LPG dual-fuel conversion",
			typeItemId: 6,
			type: "",
			direction: "left",
		},
		{
			id: 34,
			x: 50,
			y: 35,
			text: "Ethane dual-fuel conversion",
			typeItemId: 7,
			type: "",
			direction: "right",
		},
		{
			id: 35,
			x: 52,
			y: 58,
			text: "PMI Adaptive Cylinder Control (ACCo)",
			typeItemId: 10,
			type: "",
			direction: "right",
		},
		{
			id: 36,
			x: 40,
			y: 28,
			text: "EcoTuning",
			typeItemId: 9,
			type: "",
			direction: "right",
		},
		{
			id: 37,
			x: 45,
			y: 60,
			text: "AutoTorque",
			typeItemId: 11,
			type: "",
			direction: "right",
		},
		{
			id: 38,
			x: 72,
			y: 55,
			text: "AutoTorque",
			typeItemId: 125,
			type: "",
			direction: "left",
		},
		{
			id: 39,
			x: 35,
			y: 45,
			text: "Low Sulphur Fuel Nozzle",
			typeItemId: 12,
			type: "",
			direction: "right",
		},
		{
			id: 40,
			x: 65,
			y: 50,
			text: "Low Sulphur Fuel Nozzle",
			typeItemId: 126,
			type: "",
			direction: "left",
		},
	],
	categories: [
		{
			id: 1,
			type: "category",
			text: {
				en: "Decarbonization & fuel efficiency",
				de: "Decarbonization & fuel efficiency",
			},
			selection: true,
			selected: false,
		},
		{
			id: 2,
			type: "category",
			text: {
				en: "Operational Efficiency",
				de: "Operational Efficiency",
			},
			selection: true,
			selected: false,
		},
		{
			id: 3,
			type: "category",
			text: {
				en: "Regulatory Compliance",
				de: "Regulatory Compliance",
			},
			selection: true,
			selected: false,
		},
		{
			id: 4,
			type: "category",
			text: {
				en: "Safety Improvement",
				de: "Safety Improvement",
			},
			selection: true,
			selected: false,
		},
		{
			id: 5,
			type: "category",
			text: {
				en: "High flexibility",
				de: "High flexibility",
			},
			selection: true,
			selected: false,
		},
	],
	engines: [
		{
			id: 1,
			type: null,
			image: "/apps/configurators/two-stroke-engines/assets/images/MC-MC-C.png",
			text: {
				en: "MC/MC-C",
				de: "MC/MC-C",
			},
		},
		{
			id: 2,
			type: null,
			image:
				"/apps/configurators/two-stroke-engines/assets/images/ME-ME-C-ME-B.png",
			text: {
				en: "ME/ME-B/ME-C",
				de: "ME/ME-B/ME-C",
			},
		},
	],
	cart: {
		title: {
			de: "bookmarked solutions",
			en: "bookmarked solutions",
		},
	},
	navigation: [
		{
			key: "",
			title: {
				en: "",
				de: "",
			},
			panelItems: [999, 1000, 2000, 3000, 4000],
		},
	],
};
